import {
  Menu as ChakraUIMenu,
  MenuButton,
  MenuList,
  MenuItem as ChakraUIMenuItem,
  Icon
} from "@chakra-ui/react";
import { ReactNode } from "react";
import { FiMoreVertical } from "react-icons/fi";

export interface MenuProps {
  children: ReactNode;
  ariaLabelVerticalDotsIcon?: string;
  menuAriaLabel?: string;
  menuButtonAriaLabel?: string;
}

function Menu(props: MenuProps) {
  const {
    ariaLabelVerticalDotsIcon,
    children,
    menuAriaLabel,
    menuButtonAriaLabel
  } = props;

  return (
    <ChakraUIMenu gutter={8} placement="left" autoSelect={false}>
      <MenuButton
        aria-label={menuButtonAriaLabel}
        onClick={(e) => e.stopPropagation()}
        sx={{
          _focusVisible: { boxShadow: "outline" },
          span: { display: "flex" }
        }}
        role="button"
      >
        <Icon
          justifySelf="flex-start"
          aria-label={ariaLabelVerticalDotsIcon}
          minW={6}
          h={6}
          as={FiMoreVertical}
          data-testid="card-moreOptionIcon"
        />
      </MenuButton>
      <MenuList
        display="inline-flex"
        flexDirection="column"
        alignItems="flex-start"
        borderColor="gray.200"
        color="gray.800"
        minW={160}
        py={2}
        px={0}
        gap={{ base: 2, xl: 1 }}
        onClick={(e) => e.stopPropagation()}
        aria-label={menuAriaLabel}
        sx={{
          "& > button": {
            display: "flex",
            h: { base: 12, xl: 10 },
            gap: 2,
            py: 2.5,
            px: 3,
            alignItems: "center",
            fontSize: 14,
            fontWeight: 400,
            _focusVisible: { boxShadow: "outline" }
          },
          "& span": {
            mx: 0
          },
          "& svg": {
            w: 5,
            h: 5
          }
        }}
      >
        {children}
      </MenuList>
    </ChakraUIMenu>
  );
}

Menu.Item = ChakraUIMenuItem;
export { Menu };
